import { jwtDecode } from 'jwt-decode';

// An expired token left in localStorage is worse than no token at all: the admin
// panel renders as if signed in, then every authenticated request 401s and the
// page looks half-broken. Treat expired and malformed tokens as signed out.

const EXPIRY_SKEW_MS = 5000; // don't accept a token about to die mid-request

export function getValidAccessToken() {
  const token = localStorage.getItem('access_token');
  if (!token) return null;
  try {
    const { exp } = jwtDecode(token);
    if (!exp || exp * 1000 - EXPIRY_SKEW_MS <= Date.now()) return null;
    return token;
  } catch (err) {
    return null; // not a JWT we can read
  }
}

export function clearSession() {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
}

/** Send the browser to the login page, dropping any stale credentials first. */
export function redirectToLogin() {
  clearSession();
  if (window.location.pathname !== '/login') {
    window.location.assign('/login');
  }
}

const checkAuth = () => getValidAccessToken() !== null;

export default checkAuth;
